/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useState } from 'react'
import { useForm } from "react-hook-form"

import './PanelEdit.scss'

import Menu from '../../../../components/InternalMenu/Menu'

import { notify } from '../../../../components/Toast'

import { useParams } from 'react-router'
import { useNavigate } from 'react-router-dom'

import { ToastContainer } from 'react-toastify'

import { get, deleteItem, put } from '../../../../services/http'

import { baseUrl } from '../../../../Data'

export default function index() {
  const navigate = useNavigate()
  const { id } = useParams()
  document.title = 'ویرایش رستوران یا کافی شاپ'

  const { register, handleSubmit, reset } = useForm()
  
  const [timePartCount, setTimePartCount] = useState(2)
  // eslint-disable-next-line no-unused-vars
  const [timePart, setTimePart] = useState([{ id : 1 }])
  const [file, setFile] = useState()
  const [resturant, setResturant] = useState()
  const [clickButton, setClickButton] = useState(false)

  const [modal, setModal] = useState(false)
  const [cover, setCover] = useState(false)

  const [withPic, setWithPic] = useState(false)
  
  const timeHandler = () => {
    setTimePartCount(timePartCount + 1)
    setTimePart(oldArray => [...oldArray, { id : timePartCount}])
  }

  const token = localStorage.getItem('token')

  useEffect(() => {
    get(`/api/admin/im/shops/${id}?token=${token}`)
      .then(response => {
        setResturant(response.data.data[0])

        let defaultValues = {}
        defaultValues.name = response.data.data[0].name
        defaultValues.description = response.data.data[0].description
        defaultValues.address = response.data.data[0].address
        defaultValues.tell = response.data.data[0].tell
        defaultValues.about = response.data.data[0].about
        defaultValues.instagram = response.data.data[0].instagram
        defaultValues.tellegram = response.data.data[0].tellegram
        defaultValues.twitter = response.data.data[0].twitter
        defaultValues.whatsapp = response.data.data[0].whatsapp
        defaultValues.logoUrl = response.data.data[0].logoUrl
        reset({ ...defaultValues })
      }).catch(error => {
        notify('error', 'دریافت اطلاعات با خطا مواجه شد')
      })
  }, [id, reset, token])

  const onSubmit = (data, e) => {
    e.preventDefault()
    setClickButton(true)

    let count = 0
    const timesArray = []
    while(count < JSON.parse(resturant.times).length) {
      const item =  {
        day: data['days' + count],
        time: data['time' + count]
      }
      timesArray.push(item)
      count++
    }

    let formData = new FormData()

    const config = {
      headers: {
        'content-type': 'multipart/form-data'
      }
    } 
    if (withPic) {
      formData.append('logo', file)
      formData.append('name', data.name)
      formData.append('description', data.description)
      formData.append('address', data.address)
      formData.append('tell', data.tell)
      formData.append('email', data.email)
      formData.append('about', data.about)
      formData.append('times', JSON.stringify(timesArray))
      formData.append('instagram', data.instagram)
      formData.append('tellegram', data.tellegram)
      formData.append('twitter', data.twitter)
      formData.append('whatsapp', data.whatsapp)

      put(`/api/admin/im/shops/${id}?token=${token}`, formData, config)
        .then(response => {
          setTimeout(() => {
            navigate('/im/resturants')
          }, 2000)
          notify('success', response.data.messageFa)
        })
        .catch(error => {
          setClickButton(false)
          if (error) {
            notify('error', error)
          }
          notify('error', 'خطا در ارسال اطلاعات')
        })
    } else {
      const dataForm = {
        name: data.name,
        description: data.description,
        address: data.address,
        tell: data.tell,
        email: data.email,
        about: data.about,
        times: JSON.stringify(timesArray),
        instagram: data.instagram,
        tellegram: data.tellegram,
        twitter: data.twitter,
        whatsapp: data.whatsapp
      }

      put(`/api/admin/im/shops/withoutpic/${id}?token=${token}`, dataForm)
        .then(response => {
          notify('success', response.data.messageFa)
          setTimeout(() => {
            navigate('/im/resturants')
          }, 2000)
        })
        .catch(error => {
          if (error) {
            notify('error', error)
          }
          notify('error', 'خطا در ارسال اطلاعات')
        })
    }
  }

  const deleteHandler = (e) => {
    deleteItem(`/api/admin/im/shops/${id}?token=${token}`)
      .then(response => {
        setCover(false)
        setModal(false)
        notify('success', response.data.messageFa)
        setTimeout(() => {
          navigate('/im/resturants')
        }, 2000)
      })
      .catch(error => {
        if (error) {
          notify('error', error)
        }
        notify('error', 'خطا در ارسال اطلاعات')
      })
  }

  const picHandler = () => {
    setWithPic(true)
  }

  return (
    <main id='panel'>
      <div className="cover" style={{ display: cover? '': 'none' }}>
      </div>
      <div className='deleteModal' style={{ display: modal? '': 'none' }}>
        <div className="textDeleteModal">
          آیا میخواهید رستوان یا کافی شاپ حذف شود؟
        </div>
        <hr />
        <div className="buttons">
          <button onClick={deleteHandler}>حذف شود</button>
          <button onClick={e => {
            setCover(false)
            setModal(false)
          }}>انصراف</button>
        </div>
      </div>
      <ToastContainer rtl />
      <Menu page={'resturant'} badgeCountDashboard={0} badgeCountOrder={0} />
      <article className='panelBody'>
        <section className='panelContent'>
          <div className='title'>
            <div className='right' style={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
              <div className='text'>
                ویرایش رستوران‌ یا کافی شاپ‌
              </div>
              <div>
                <button onClick={e => { 
                  setCover(true)
                  setModal(true) }} style={{ backgroundColor: '#ff6666' }} className='createButton' type='submit'> حذف رستوران‌ یا کافی شاپ‌</button>
              </div>
            </div>

            <div className='left'>
            </div>
          </div>

          <form className='form' onSubmit={handleSubmit(onSubmit)}>
            <div className='title'>
              * لطفا تمامی فیلد های مشخص شده را پر کنید.
            </div>
            <div className='lineTitle'>
              <hr />
              اطلاعات رستوران
              <hr />
            </div>
            <div className='row'>
              <div className='column'>
                <label htmlFor='resturantName'>نام رستوران * :</label>
                <input id='resturantName' {...register("name", { required: true, minLength: 5 })} type='text' placeholder='فست فود تبریز' />
                <small id='resturantNameAlert'>نام رستوران باید وارد شود</small>
              </div>
              <div className='column'>
                <label htmlFor='resturantDetails'>توضیحات * :</label>
                <input id='resturantDetails' {...register("description", { required: true, minLength: 5 })} type='text' placeholder='شعبه ...' />
                <small id='resturantDetailsAlert'>توضیحات باید وارد شود</small>
              </div>
            </div>
            <div className='row'>
              <div className='column'>
                <label htmlFor='resturantAddress'>آدرس * :</label>
                <input id='resturantAddress' {...register("address", { required: true, minLength: 5 })} type='text' placeholder='شهر - خیابان - ...' />
                <small id='resturantAddressAlert'>آدرس باید وارد شود</small>
              </div>
              <div className='column'>
                <label htmlFor='resturantTell'>تلفن * :</label>
                <input id='resturantTell' {...register("tell", { required: true, minLength: 5 })} type='tel' placeholder='04...' />
                <small id='resturantTellAlert'>تلفن باید وارد شود</small>
              </div>
            </div>
            <div className='row'>
              <div className='column'>
                <label htmlFor='resturantEmail'>ایمیل * :</label>
                <input id='resturantEmail' defaultValue={resturant ? resturant.email : ''} {...register("email", { required: true, minLength: 5 })} type='email' placeholder='info@...' />
                <small id='resturantAlert'>ایمیل باید وارد شود</small>
              </div>
            </div>
            <div className='row'>
              <div className='column textarea'>
                <label htmlFor='resturantEmail'>درباره * :</label>
                <textarea id='resturantEmail' {...register("about", { required: true, minLength: 5 })} rows={5} placeholder='سال شروع ...' />
                <small id='resturantAlert'>درباره ما باید وارد شود</small>
              </div>
            </div>
            <div className='lineTitle'>
              <hr />
              ساعات کاری مجموعه
              <hr />
            </div>
            {resturant ? JSON.parse(resturant.times).map((item, index) => (
              <div className='row' key={index}>
                <div className='column'>
                  <label htmlFor='resturantDay'>روز کاری مجموعه * :</label>
                  <input id='resturantDay' defaultValue={item.day} {...register(`days${index}`, { required: true, minLength: 3 })} type='text' placeholder='از شنبه تا چهارشنبه' />
                  <small id='resturantDayAlert'>روز کاری مجموعه باید وارد شود</small>
                </div>
                <div className='column'>
                  <label htmlFor='resturantTime'>ساعت کاری مجموعه * :</label>
                  <input id='resturantTime' defaultValue={item.time} {...register(`time${index}`, { required: true, minLength: 3 })} type='text' placeholder='از ساعت 11 تا 1 بامداد' />
                  <small id='resturantTimeAlert'>ساعت کاری مجموعه باید وارد شود</small>
                </div>
              </div>
            )) : ''}
            <div className="row" style={{ display: 'none' }}>
              <div className="add" onClick={timeHandler}>
                +
              </div>
            </div>
            <div className='row' style={{ position: 'relative' }}>
              <div className='column' style={withPic ? {} : { display: 'none' }}>
                <label htmlFor='logo'>لوگو رستوران :</label>
                <input id='logo' onChange={e => {
                  const fileSelect = e.target.files[0]
                  setFile(fileSelect)
                }} type='file' />
                <small id='resturantAlert'>لوگو باید انتخاب شود</small>
              </div>
              <div className='column' style={withPic ? { display: 'none' } : {}}>
                <img width={'100px'} src={resturant ? `${baseUrl.address}${resturant.logoUrl}` : ''} alt='logo' />
                <div className='positiveIcon' onClick={picHandler}>+</div>
              </div>
            </div>
            <div className='lineTitle'>
              <hr />
              شبکه های اجتماعی
              <hr />
            </div>
            <div className='row'>
              <div className='column'>
                <label htmlFor='resturantInstagram'>اینستاگرام :</label>
                <input id='resturantInstagram' {...register("instagram", { required: true })} type='url' placeholder='https://www.instagram.com/...' />
              </div>
              <div className='column'>
                <label htmlFor='resturantTelegram'>تلگرام :</label>
                <input id='resturantTelegram' {...register("tellegram", { required: true })} type='url' placeholder='https://telegram.org/...' />
              </div>
            </div>
            <div className='row'>
              <div className='column'>
                <label htmlFor='resturantInstagram'>توئیتر :</label>
                <input id='resturantInstagram' {...register("twitter", { required: true })} type='url' placeholder='https://twitter.com/...' />
              </div>
              <div className='column'>
                <label htmlFor='resturantTelegram'>واتس اپ :</label>
                <input id='resturantTelegram' {...register("whatsapp", { required: true })} type='url' placeholder='https://whatsapp.com/...' />
              </div>
            </div>
            <button className='createButton' type='submit' style={clickButton ? { backgroundColor: 'gray' } : {}} disabled={clickButton ? true : false}>{clickButton ? 'در حال آپلود ...' : 'آپدیت رستوران یا کافی شاپ'}</button>
          </form>
          <div className='copyright'>
            © تمامی حقوق برای <a href='https://ibills.ir'>ibills</a> محفوظ است. طراحی و توسعه توسط <a href='https://ham-team.ir'>هم تیم</a>
          </div>
        </section>
      </article>
    </main>
  )
}
